import { inject, Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from 'sham-components/services';
import {
  NotificationMessageSource,
  renderNotificationMessage,
} from './notification-messages';

@Pipe({ name: 'notificationMessage', pure: false })
export class NotificationMessagePipe implements PipeTransform {
  private readonly language = inject(LanguageService);

  transform(
    item: NotificationMessageSource,
    part: 'title' | 'body' | 'actions',
  ): string {
    const language = this.language.currentLang();
    const message = renderNotificationMessage(item, language);
    return part === 'actions'
      ? `${language === 'ar' ? 'إجراءات الإشعار' : 'Notification actions for'} ${message.title}`
      : message[part];
  }
}
